(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("assignmentMapsResource", ["$resource", assignmentMapsResource]);
    function assignmentMapsResource($resource) {
        return $resource("/api/assignmentMaps/:id/:type/:action", {}, {
            disable: {
                method: "POST",
                params: { id: "@id", action: "disable" }
            },
            enable: {
                method: "POST",
                params: { id: "@id", action: "enable" }
            },
            redo: {
                method: "POST",
                params: { id: "@id", action: "redo" }
            },
            reassign: {
                method: "POST",
                params: { id: "@id", action: "reassign" }
            },
            assignPathToGroup: {
                method: "POST",
                params: { type: "paths-to-groups", action: "add" }
            },
            assignPathToLearners: {
                method: "POST",
                params: { type: "paths-to-learners", action: "add" }
            }
        });
    }
}());
